import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NickNameTextField } from "./LoanNickNameModal.styles";
import i18n from "../../../strings/i18n";
var NickNameInput = forwardRef(function (_a, ref) {
    var inputValue = _a.inputValue, handleInputChange = _a.handleInputChange, handleInputOnBlur = _a.handleInputOnBlur, error = _a.error;
    return (_jsx(NickNameTextField, { id: "nickname-input", name: "nick-name", "data-testid": "nickname-input", placeholder: i18n({ labels: "accountNickname" }), helpText: "".concat(inputValue.length, "/26"), error: error, errorIcon: error ? (_jsx(FontAwesomeIcon, { "data-testid": "error-icon", icon: faTriangleExclamation, size: "sm" })) : undefined, type: "text", value: inputValue, onChange: function (e) {
            return handleInputChange(e.target.value);
        }, "data-private": true, onBlur: handleInputOnBlur, textfieldRef: ref }));
});
export default NickNameInput;
//# sourceMappingURL=NickNameInput.js.map